export const getAnswerOptionLetter = (
  option: { letter?: string; optionLetter?: string },
  fallbackIndex?: number
): string =>
  option.letter ??
  option.optionLetter ??
  (typeof fallbackIndex === 'number'
    ? String.fromCharCode(65 + fallbackIndex)
    : '');

export const getAnswerOptionExplanationMain = (option: {
  explanationMain?: string | null;
  explanation_main?: string;
}): string => option.explanationMain ?? option.explanation_main ?? '';

export const getAnswerOptionExplanationTutor = (option: {
  explanationTutor?: string | null;
  explanation_tutor_mode?: string;
}): string => option.explanationTutor ?? option.explanation_tutor_mode ?? '';
